import { render, staticRenderFns } from "./CmgBag.vue?vue&type=template&id=8ae1b15c&scoped=true&lang=pug"
import script from "./cmg-bag.ts?vue&type=script&lang=ts&external"
export * from "./cmg-bag.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgBag.vue?vue&type=style&index=0&id=8ae1b15c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae1b15c",
  null
  
)

export default component.exports